import React from 'react';

/**
 * Highlightable suggestion list for typeaheads.
 * Pair with useListKeyboardNav on the input.
 */
const HighlightList = ({
  items = [],
  highlightedIndex = 0,
  setHighlightedIndex,
  setItemRef,
  onSelect,
  getKey = (item, index) => item?.Id ?? index,
  renderItem,
  className = 'absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto',
  itemClassName = 'px-3 py-2 cursor-pointer border-b border-gray-100 last:border-0',
  highlightClassName = 'bg-blue-50',
  idleClassName = 'hover:bg-blue-50',
}) => {
  if (!items.length) return null;

  return (
    <div className={className} role="listbox">
      {items.map((item, index) => {
        const isHighlighted = index === highlightedIndex;
        return (
          <div
            key={getKey(item, index)}
            role="option"
            aria-selected={isHighlighted}
            ref={(node) => setItemRef && setItemRef(index, node)}
            className={`${itemClassName} ${isHighlighted ? highlightClassName : idleClassName}`}
            onMouseEnter={() => setHighlightedIndex && setHighlightedIndex(index)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onSelect(item, index)}
          >
            {renderItem ? renderItem(item, index, isHighlighted) : String(item)}
          </div>
        );
      })}
    </div>
  );
};

export default HighlightList;
